export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "Electronic guest registration — Polizia di Stato (Italy)",

  fields: {
    utente: "Utente",
    password: "Password",
    wskey: "WsKey",
    wskeyHint: "The WsKey is generated in the portal alloggiatiweb.poliziadistato.it → Gestione dispositivi.",
    tipoStruttura: "Accommodation type",
    idAppartamento: "Apartment ID",
    idAppartamentoHint: "Apartment ID registered in Alloggiati Web.",
    keepBlank: "(leave blank to keep current value)",
  },

  tipoOptions: {
    hotel: "Hotel / B&B / Holiday home",
    appartamento: "Managed apartment",
  },

  actions: {
    saveAndVerify: "Save & verify",
    updateCredentials: "Update credentials",
    verifyConnection: "Verify connection",
    saving: "Saving...",
    verifying: "Verifying...",
  },

  status: {
    connectionOk: "Credentials saved and connection verified successfully.",
    connectionError: "Connection error. Please check the credentials entered.",
    connectionPending: "Connection not yet verified. Click \"Verify connection\" to confirm.",
  },

  validation: {
    utenteRequired: "The Utente field is required.",
    passwordRequired: "Password is required.",
    wskeyRequired: "WsKey is required.",
    idAppartamentoRequired: "The Apartment ID is required.",
  },

  toasts: {
    saveSuccess: "Credentials saved and connection verified successfully.",
    saveWarning: "Credentials saved, but the connection could not be verified.",
    saveError: "Could not save credentials.",
    testSuccess: "Alloggiati Web connection verified successfully.",
    testError: "Could not verify the connection.",
    statusActive: "Alloggiati Web activated.",
    statusInactive: "Alloggiati Web deactivated.",
  },
};
